<template>
  <div class="layout_contents">
    <!-- Title -->
    <div class="area_title">
      <div class="txt_title">{{ $t('facilityGuide.cabinLocation') }}</div>
      <div class="txt_det">{{ $t('facilityGuide.miracleIntro') }}</div>
    </div>
    <!-- //Title -->

    <div class="area_contents">
      <!-- Swiper -->
      <swiper
        class="tabs_slider"
        :modules="modules"
        :slidesPerView="'auto'"
        :space-between="12"
        navigation
        @swiper="onSwiper"
        @slideChange="onSlideChange"
      >
        <swiper-slide v-for="(room, index) in miracleRoomList" :key="index">
          <a href="javascript:" :class="{ active: currentTab === index }" @click="currentTab = index">
            {{ room.name[locale] }}
          </a>
        </swiper-slide>
      </swiper>
      <!-- //Swiper -->

      <div>
        <!-- View Room -->
        <div class="view_room">
          <!-- info Room -->
          <div class="info_room">
            <div class="info_room_content">
              <div class="data_view">{{ miracleRoomList[currentTab].category }}</div>
              <div class="name_room">{{ miracleRoomList[currentTab].name[locale] }}</div>
              <div class="room_desc" v-if="miracleRoomList[currentTab].promotionalText">
                {{ miracleRoomList[currentTab].promotionalText[locale] }}
              </div>
              <div class="room_desc sub">{{ miracleRoomList[currentTab].promotionalSubText[locale] }}</div>

              <ul class="list_info">
                <li v-for="item in convertDescription">{{ item }}</li>
              </ul>
            </div>

            <div class="detail_image_list">
              <swiper
                class="tab_menu"
                :modules="modules"
                :slidesPerView="3"
                navigation
                @swiper="onSwiper"
                @slideChange="onSlideChange"
              >
                <swiper-slide
                  v-for="(item, index) in detailsImageBodyList[currentTab]"
                  :key="index"
                  :class="{ active: imageActiveTab[currentTab] === index }"
                >
                  <a href="javascript:" @click="imageActiveTab[currentTab] = index">
                    <img :src="item.url" />
                  </a>
                </swiper-slide>
              </swiper>
            </div>
          </div>
          <!-- //info Room -->

          <div class="tab_content">
            <img :src="selectedImageUrl" />
          </div>
        </div>
        <!-- //View Room -->
        <!-- Location -->
        <div class="view_location" v-if="currentLocationImageUrl">
          <div class="label_location">{{ $t('facilityGuide.location') }}</div>
          <div class="local_image">
            <img :src="currentLocationImageUrl" />
          </div>
        </div>
        <!-- //Location -->
      </div>
    </div>
  </div>
</template>

<script>
import { Navigation } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/vue';

import 'swiper/css/navigation';
import 'swiper/css';

export default {
  name: 'MiracleRoom',
  components: {
    Swiper,
    SwiperSlide,
  },
  data() {
    return {
      currentTab: 0,
      imageActiveTab: [],
      miracleRoomList: [
        // {
        //   category: 'SUITE',
        //   name: {
        //     ko: '프레지덴셜 스위트',
        //     en: 'Presidential Suite',
        //     ja: 'プレジデントスイート客室',
        //   },
        //   promotionalText: {
        //     ko: '크루즈 최고의 럭셔리 객실',
        //     en: 'The Pinnacle of Luxury On Board',
        //     ja: 'クルーズで最高のラグジュアリーな客室',
        //   },
        //   promotionalSubText: {
        //     ko: 'VIP 전용 서비스를 비롯해 고급 시설과 최고의 서비스를 자랑합니다.',
        //     en: 'Offering VIP services and premium amenities.',
        //     ja: 'VIP 専用サービスをはじめ、お客様のための高級施設と最高のサービスをご提供しております。',
        //   },
        //   description: {
        //     ko: '객실 면적: 36.7㎡\n정원: 2명\n바다 조망\n넓은 발코니, 욕조, 6 인용 소파, 화장대, 냉장고, TV',
        //     en: 'Room Size : 36.7㎡\nCapacity : 2 people\nFeatures: Large Balcony, Bathtub, Six-Person Sofa, Dressing Table, Refrigerator, TV',
        //     ja: '客室面積：36.7㎡\n定員：2名\n広々としたバルコニー、バスタブ、 6 人用ソファー、ドレッサー、冷蔵庫、テレビ',
        //   },
        //   gradeImages: [
        //     {
        //       category: 'details',
        //       url: require('@/assets/images/information/facility/miracle_presidential_room01.png'),
        //     },
        //     {
        //       category: 'details',
        //       url: require('@/assets/images/information/facility/miracle_presidential_room02.jpeg'),
        //     },
        //     {
        //       category: 'location',
        //       url: require('@/assets/images/information/facility/miracle_presidential_location.svg'),
        //     },
        //   ],
        // },
        {
          category: 'SUITE',
          name: {
            ko: '로얄 스위트',
            en: 'Royal Suite',
            ja: 'ロイヤルスイート客室',
          },
          promotionalText: {
            ko: '고급스러운 디자인과 넓은 공간을 자랑하는 객실',
            en: 'Elegant and Spacious Environment',
            ja: '高級デザインと広々空間の客室',
          },
          promotionalSubText: {
            ko: '전용 라운지와 발코니에서 바다를 감상할 수 있으며, 최고급 어메니티와 특별한 서비스를 제공합니다.',
            en: 'Relax on the sofa and immerse yourself in the beauty of the open sea.',
            ja: '専用ラウンジとバルコニーで海を楽しめる、最高級アメニティと特別サービスを提供します。',
          },
          description: {
            ko: '객실 면적: 17.0㎡\n정원: 3명\n바다 조망\n발코니, 소파, 화장대, 미니 냉장고, TV, 샤워룸',
            en: 'Room Size : 17.0㎡\nCapacity : 2-3 people\nFeatures : Balcony, Sofa, Dressing Table, Mini-Refrigerator, TV, Shower Room',
            ja: '客室面積：17.0㎡\n定員：2~3名\nバルコニー、ソファー、ドレッサー、ミニ冷蔵庫、テレビ、シャワールーム',
          },
          gradeImages: [
            {
              category: 'details',
              url: require('@/assets/images/information/facility/miracle_royal_room01.png'),
            },
            {
              category: 'location',
              url: require('@/assets/images/information/facility/miracle_royal_location.jpg'),
            },
          ],
        },
        {
          category: 'SUITE',
          name: {
            ko: '발코니 스위트',
            en: 'Balcony Suite',
            ja: 'バルコニースイート客室',
          },
          promotionalText: {
            ko: '넓은 침실과 전용 발코니가 완벽하게 조화를 이룬 객실',
            en: 'Cozy and Private Escape',
            ja: '広々とした寝室と専用バルコニーが調和した部屋',
          },
          promotionalSubText: {
            ko: '언제든지 발코니에서 바다의 경치를 감상하며 프라이빗한 휴식을 즐길 수 있는 객실입니다.',
            en: 'Step onto your balcony for panoramic ocean views, and relax in the warm, inviting space.',
            ja: 'いつでもバルコニーから海の景色を眺めながらプライベートな休息を楽しめる客室です。',
          },
          description: {
            ko: '객실 면적: 12.6㎡\n정원: 2명\n발코니, 화장대, 미니 냉장고, TV, 샤워룸',
            en: 'Room Size : 12.6 ㎡\nCapacity : 2-3 people\nFeatures: Balcony, Dressing Table, Mini-Refrigerator, TV, Shower Room',
            ja: '客室面積：12.6 ㎡\n定員：2~3名\nバルコニー、ドレッサー、ミニ冷蔵庫、テレビ、シャワールーム',
          },
          gradeImages: [
            {
              category: 'details',
              url: require('@/assets/images/information/facility/miracle_balcony_room01.png'),
            },
            {
              category: 'location',
              url: require('@/assets/images/information/facility/miracle_balcony_location.jpg'),
            },
          ],
        },
        {
          category: 'NORMAL',
          name: {
            ko: '오션뷰',
            en: 'Oceanview Room',
            ja: 'オーシャンビュー客室',
          },
          promotionalText: {
            ko: '아름다운 바다 전망을 자랑하는 오션뷰 객실',
            en: 'Stylish Space for Enjoying Scenic Ocean Views',
            ja: '美しい海の眺めを誇るオーシャンビューの客室',
          },
          promotionalSubText: {
            ko: '아늑하면서도 세련된 공간으로, 창을 통해 펼쳐지는 바다 경치를 편안하게 감상할 수 있습니다.',
            en: 'A cozy, refined space to enjoy expansive ocean views through the window.',
            ja: '居心地のよい洗練された空間で、窓から広がる海の景色を快適に鑑賞することができます。',
          },
          description: {
            ko: '객실 면적: 11.6㎡\n정원: 4명\n창문, 캡슐침대, 소파, 화장대, 미니 냉장고, TV, 샤워룸',
            en: 'Room Size : 11.6㎡\nCapacity : 2-4 people\nFeatures: Window, Capsule Beds, Sofa, Dressing Table, Mini-Refrigerator, TV, Shower Room',
            ja: '客室面積：11.6㎡\n定員：2~4名\n窓、カプセルベッド、ソファー、ドレッサー、ミニ冷蔵庫、TV、シャワールーム',
          },
          gradeImages: [
            {
              category: 'details',
              url: require('@/assets/images/information/facility/miracle_oceanview_room01.jpeg'),
            },
            {
              category: 'location',
              url: require('@/assets/images/information/facility/miracle_oceanview_location.jpg'),
            },
          ],
        },
        {
          category: 'INSIDE',
          name: {
            ko: '인사이드',
            en: 'Inside Room',
            ja: 'インサイド客室',
          },
          promotionalText: {
            ko: '아늑하고 실용적인 공간에서\n편안한 휴식을 누릴 수 있는 객실',
            en: 'Cozy and practical space for a restful stay.',
            ja: '心地よく実用的な空間で、快適な休息を。',
          },
          promotionalSubText: {
            ko: '소박하지만 따뜻한 분위기와 기본 편의시설을 갖추어, 여행 중에도 안락함을 제공합니다.',
            en: 'With a simple yet warm atmosphere and amenities, we offer you comfort and relaxtion.',
            ja: '素朴ながら温かみのある雰囲気と基本的な設備を備え、旅行中もくつろぎのひとときを提供します。',
          },
          description: {
            ko: '객실 면적: 11.6㎡\n정원: 4명\n캡슐침대, 소파, 화장대, 미니 냉장고, TV, 샤워룸',
            en: 'Room Size : 11.6㎡\nCapacity : 4 people\nFeatures: Capsule Beds, Sofa, Dressing Table, Mini-Refrigerator, TV, Shower Room',
            ja: '客室面積：11.6㎡\n定員：4名\nカプセルベッド、ソファー、ドレッサー、ミニ冷蔵庫、TV、シャワールーム',
          },
          gradeImages: [
            {
              category: 'details',
              url: require('@/assets/images/information/facility/miracle_inside_room01.png'),
            },
            {
              category: 'location',
              url: require('@/assets/images/information/facility/miracle_inside_location.png'),
            },
          ],
        },
      ],

      detailsImageBodyList: [],
      locationImageBodyList: [],
    };
  },
  watch: {
    currentTab() {
      this.imageActiveTab[this.currentTab] = 0;
    },
  },
  computed: {
    locale() {
      return this.$i18n.locale;
    },
    selectedImageUrl() {
      return this.detailsImageBodyList[this.currentTab]?.[this.imageActiveTab[this.currentTab]]?.url || '';
    },
    currentLocationImageUrl() {
      return this.locationImageBodyList[this.currentTab]?.url || '';
    },
    convertDescription() {
      return this.miracleRoomList[this.currentTab].description[this.locale].split('\n');
    },
  },
  methods: {
    showTabContent(imageSrc) {
      this.selectedTabImageSrc = imageSrc;
    },
    getMiracleRoomList() {
      // TODO: API 연동
      this.detailsImageBodyList = this.miracleRoomList.map(item =>
        item.gradeImages.filter(image => image.category === 'details'),
      );
      this.locationImageBodyList = this.miracleRoomList.map(item =>
        item.gradeImages.find(image => image.category === 'location'),
      );

      this.imageActiveTab = Array(this.miracleRoomList.length).fill(0);
    },
  },
  setup() {
    const onSwiper = () => {};
    const onSlideChange = () => {};
    return {
      onSwiper,
      onSlideChange,
      modules: [Navigation],
    };
  },
  created() {
    this.getMiracleRoomList();
  },
};
</script>

<style scoped>
.tabs_slider {
  padding: 6px 0;
  margin-bottom: 60px;
}
.tabs_slider .swiper-slide {
  width: auto !important;
  margin-right: 12px;
}
.tabs_slider .swiper-slide a {
  display: inline-block;
  padding: 0 28px;
  border-radius: 100px;
  border: 1px solid #446ceb;
  font-weight: 600;
  color: #446ceb;
  font-size: 20px;
  line-height: 54px;
  background-color: #fff;
}
.tabs_slider .swiper-slide a.active {
  background-color: #446ceb;
  color: #fff;
}
.tabs_slider :deep(.swiper-button-prev),
.tabs_slider :deep(.swiper-button-next) {
  width: 70px;
  height: 62px;
  top: 4px;
  margin: 0;
  background-color: #fff;
}
.tabs_slider :deep(.swiper-button-prev) {
  left: 0;
}
.tabs_slider :deep(.swiper-button-next) {
  right: 0;
}

.tabs_slider :deep(.swiper-button-prev:before),
.tabs_slider :deep(.swiper-button-next:before) {
  position: absolute;
  top: 1px;
  width: 60px;
  height: 60px;
  border-radius: 50%;
  background-color: #fff;
  box-shadow: 0px 2px 6px 0px rgba(0, 0, 0, 0.2);
  content: '';
  flex: none;
}
.tabs_slider :deep(.swiper-button-prev:before) {
  left: 5px;
}
.tabs_slider :deep(.swiper-button-next:before) {
  right: 5px;
}
.tabs_slider :deep(.swiper-button-prev.swiper-button-disabled),
.tabs_slider :deep(.swiper-button-next.swiper-button-disabled) {
  display: none;
}
.tabs_slider :deep(.swiper-wrapper) {
  height: 56px;
}
.tabs_slider :deep(.swiper-button-prev:after),
.tabs_slider :deep(.swiper-button-next:after) {
  color: #b6bbbf;
  font-weight: bold;
  font-size: 20px;
  z-index: 1;
}
.tabs_slider :deep(.swiper-button-prev:after) {
  margin-left: -2px;
}
.tabs_slider :deep(.swiper-button-next:after) {
  margin-right: -2px;
}
.tabs_slider :deep(.swiper-wrapper) {
  height: auto;
  padding: 2px 2px;
  margin: 0 -2px;
}

.view_room {
  display: flex;
  gap: 20px;
}
.view_room .info_room {
  width: 482px;
  height: 439px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.view_room .info_room .data_view {
  color: #9299a0;
  font-size: 19px;
  line-height: 24px;
  margin-bottom: 4px;
}
.view_room .info_room .name_room {
  color: var(--Blue-blue-700, #304da7);
  font-size: 28px;
  font-weight: 600;
  line-height: 24px; /* 85.714% */
  letter-spacing: -1.5px;
  margin-bottom: 24px;
}
.view_room .info_room .room_desc {
  color: var(--Grey-grey-800, #505458);
  font-size: 22px;
  font-weight: 600;
  line-height: 24px;
  white-space: pre-wrap;
}
.view_room .info_room .room_desc.sub {
  font-weight: 400;
}
.view_room .info_room .list_info {
  margin-top: 28px;
}
.view_room .info_room .list_info li {
  color: var(--Grey-grey-700, #686d72);
  display: flex;
  align-items: flex-start;
  font-size: 20px;
  line-height: 180%;
  letter-spacing: -0.4px;
}
.view_room .info_room .list_info li:before {
  position: relative;
  top: 2px;
  margin: 13px;
  display: inline-block;
  width: 4px;
  height: 4px;
  border-radius: 50%;
  background-color: #b6bbbf;
  content: '';
}
.detail_image_list {
  position: relative;
  width: 420px;
  height: 90px;
}
.view_room .tab_menu {
  position: static;
  border-radius: 7px;
  width: 100%;
  height: 100%;
  margin: 0;
}
.view_room .tab_menu .swiper-slide {
  opacity: 0.6;
  width: 140px;
  height: 100%;
}
.view_room .tab_menu .swiper-slide.active {
  opacity: 1;
}
.view_room .tab_menu .swiper-slide a img {
  width: 140px;
  height: 100%;
}
.view_room .tab_menu .swiper-slide:last-child a img {
  border-radius: 0 7px 7px 0;
}
.view_room .tab_menu .swiper-slide a {
  display: block;
  width: 100%;
  height: 100%;
}
.view_room .tab_menu :deep(.swiper-button-prev),
.view_room .tab_menu :deep(.swiper-button-next) {
  width: 30px;
  height: 30px;
  transform: translateY(-50%);
  margin: 0;
}
.view_room .tab_menu :deep(.swiper-button-prev) {
  left: -15px;
}
.view_room .tab_menu :deep(.swiper-button-next) {
  right: -15px;
}
.view_room .tab_menu :deep(.swiper-button-prev:before),
.view_room .tab_menu :deep(.swiper-button-next:before) {
  position: absolute;
  top: 0;
  width: 30px;
  height: 30px;
  border-radius: 50%;
  background-color: #fff;
  box-shadow: 0px 2px 6px 0px rgba(0, 0, 0, 0.2);
  content: '';
  flex: none;
}
.view_room .tab_menu :deep(.swiper-button-prev:before) {
  left: 0;
}
.view_room .tab_menu :deep(.swiper-button-next:before) {
  right: 5px;
  right: 0;
}
.view_room .tab_menu :deep(.swiper-button-prev.swiper-button-disabled),
.view_room .tab_menu :deep(.swiper-button-next.swiper-button-disabled) {
  display: none;
}
.view_room .tab_menu :deep(.swiper-button-prev:after),
.view_room .tab_menu :deep(.swiper-button-next:after) {
  color: #b6bbbf;
  font-weight: bold;
  font-size: 10px;
  z-index: 1;
}
.view_room .tab_menu :deep(.swiper-button-prev:after) {
  margin-left: -2px;
}
.view_room .tab_menu :deep(.swiper-button-next:after) {
  margin-right: -2px;
}
.view_room .tab_content {
  flex: auto;
  height: 439px;
  overflow: hidden;
  border-radius: 16px;
}
.view_location {
  margin: 60px 0 0 0;
}
.view_location .local_image {
  overflow: auto;
  box-shadow: 0px 2px 6px 0px rgba(0, 0, 0, 0.2);
  border-radius: 10px;
  width: 100%;
  background: white;
}
.view_location .label_location {
  margin-bottom: 24px;
  color: #505458;
  font-weight: 600;
  line-height: 24px;
  font-size: 22px;
}

@media (max-width: 767px) {
  .view_room .tab_content {
    height: 234px;
    border-radius: 5px;
  }
  .view_room {
    flex-direction: column;
    margin-top: 24px;
  }
  .view_room .info_room {
    width: 100%;
    height: auto;
    gap: 16px;
  }
  .view_room .info_room .name_room {
    font-size: 22px;
    margin-bottom: 16px;
  }
  .view_room .info_room .room_desc {
    font-size: 18px;
    white-space: normal;
  }
  .view_room .info_room .list_info {
    margin-bottom: 8px;
  }
  .view_room .info_room .list_info li {
    font-size: 16px;
    line-height: 140%; /* 22.4px */
    letter-spacing: -0.32px;
  }
  .view_room .info_room .list_info li:before {
    margin-top: 6px;
  }
  .view_room .info_room .list_info li + li {
    margin-top: 8px;
  }
  .detail_image_list {
    width: 100%;
    height: auto;
    min-height: 70px;
  }
  .view_room .tab_menu {
    width: unset;
  }
  .view_room .tab_menu .swiper-slide {
    width: 33.333333% !important;
    height: unset;
  }
  .view_room .tab_menu .swiper-slide a img {
    width: 100%;
    height: 100%;
  }
  .view_room .tab_menu :deep(.swiper-button-prev),
  .view_room .tab_menu :deep(.swiper-button-next) {
    display: none;
  }
  .view_location {
    margin: 20px 0 0 0;
  }
  .view_location .local_image img {
    width: auto;
    height: 190px;
  }
  .view_location .label_location {
    margin-bottom: 16px;
    font-size: 18px;
    line-height: 24px;
  }
  .tabs_slider {
    margin-bottom: 24px;
  }
  .tabs_slider :deep(.swiper-wrapper) {
    height: 41px;
  }
  .tabs_slider :deep(.swiper-button-next),
  .tabs_slider :deep(.swiper-button-prev) {
    display: none !important;
  }

  .tabs_slider .swiper-slide {
    margin-right: 8px;
  }
  .tabs_slider .swiper-slide a {
    font-size: 14px;
    padding: 0 12px;
    line-height: 39px;
  }
  .view_room .info_room .list_info .txt_info {
    font-size: 16px;
    line-height: 22px;
  }
}
</style>
